export async function loadAllDocumentPages(fetchPage,filters) {
  const unpack=response=>response?.data?.success !== undefined ? response.data : response;
  const first=unpack(await fetchPage({...filters,page:1,limit:200}));
  if(!first?.success) throw new Error(first?.message || 'โหลดเอกสารไม่สำเร็จ');
  const rows=[...first.data];
  for(let page=2;page<=(first.pagination?.totalPages||1);page++) {
    const next=unpack(await fetchPage({...filters,page,limit:200}));
    if(!next?.success) throw new Error(next?.message || 'โหลดเอกสารไม่ครบ');
    rows.push(...next.data);
  }
  return {...first,data:rows};
}
